import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f0bc9548"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ion-text-right"
}

import { IonAccordionGroup, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonPage, IonPopover, IonTitle, IonToolbar, modalController, onIonViewDidEnter } from '@ionic/vue'
import { addCircleOutline, ellipsisVertical } from 'ionicons/icons'
import NotificationsBanner from '@/components/NotificationsBanner.vue'
import ScheduleItem from '@/components/ScheduleItem.vue'

import { computed, onMounted, ref } from 'vue'
import { useEventStore, EventScheduleItem } from '@/store/event'
import { format } from '@/lib/date-fns-local'
import { useTimestamp } from '@vueuse/core'
import { App } from '@capacitor/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventScheduleTab',
  setup(__props) {

const openedScheduleItem = ref()
const $store = useEventStore()

const days = computed<Map<string, EventScheduleItem[]>>(() => {
  const days = new Map()
  $store.schedule.slice()
    .sort((a, b) => a.time.start.valueOf() - b.time.start.valueOf())
    .forEach(item => {
      const day = item.time.start.toDateString()
      const collection = days.get(day)
      if (collection) {
        collection.push(item)
      } else {
        days.set(day, [item])
      }
    })

  return days
})

const currentTime = useTimestamp({ interval: 60000 })
const ongoingItem = computed(() => {
  const now = new Date(currentTime.value)
  const day = days.value.get(now.toDateString())
  if (!day) return undefined
  
  for (let i = day.length - 1; i >= 0; i--) {
    if (day[i].time.start <= now) {
      return day[i]
    }
  }
  return day[0]
})

function scrollToOngoingItem () {
  if (!ongoingItem.value) return
  const cursor = document.getElementById('ongoing-cursor')
  if (!cursor) return
  cursor.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

onMounted(scrollToOngoingItem)
onIonViewDidEnter(scrollToOngoingItem)
App.addListener('appStateChange', async ({ isActive }) => {
  if (isActive) scrollToOngoingItem()
})


async function createScheduleItem (defaultStartTime?: Date) {
  if (!defaultStartTime && days.value.size) {
    const lastDay = Array.from(days.value.values()).pop()
    defaultStartTime = lastDay?.pop()?.time.start
  }
  const ScheduleItemForm = await import('@/components/ScheduleItemForm.vue')
  return (await modalController.create({
    component: ScheduleItemForm.default,
    componentProps: { defaultStartTime },
    ...ScheduleItemForm.modalOptions
  })).present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), {
            class: "event-banner__header",
            mode: "ios",
            style: _normalizeStyle({ backgroundImage: `url(${_unref($store).event?.bannerUrl})` })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { class: "event-banner__actions" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    id: `trigger-${_ctx.$.uid}`,
                    style: { color: 'currentColor' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(ellipsisVertical)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["id"]),
                  _createVNode(_unref(IonPopover), {
                    trigger: `trigger-${_ctx.$.uid}`,
                    "trigger-action": "click",
                    "dismiss-on-select": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonList), {
                        lines: "full",
                        class: "ion-no-padding"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonItem), {
                            "router-link": "/events",
                            "router-direction": "back",
                            detail: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Přepnout událost ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["trigger"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), {
                    size: "large",
                    class: "event-banner__title"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($store).event?.displayName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          (_unref($store).event)
            ? (_openBlock(), _createBlock(NotificationsBanner, {
                key: 0,
                "event-id": _unref($store).event.id
              }, null, 8, ["event-id"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, ([day, items]) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: day }, [
              _createVNode(_unref(IonListHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(format)(new Date(day), 'EEEE')), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (_unref($store).currentMember?.canWrite)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        size: "small",
                        fill: "clear",
                        onClick: ($event: any) => (createScheduleItem(items[0].time.start))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(addCircleOutline)
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IonAccordionGroup), {
                modelValue: openedScheduleItem.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openedScheduleItem).value = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                    return (_openBlock(), _createBlock(ScheduleItem, {
                      key: item.id,
                      value: item.id,
                      item: item,
                      "is-current": ongoingItem.value?.id === item.id
                    }, null, 8, ["value", "item", "is-current"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ], 64))
          }), 128)),
          (_unref($store).currentMember?.canWrite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(IonButton), {
                  size: "small",
                  fill: "clear",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (createScheduleItem()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(addCircleOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})